import { POST, comprarPedido, server } from "@/state/server";
import { useState } from "react";
import { useConfigContext } from "../state/configContext";
import { SelectProducto } from "./SelectProducto";
import type { Pedido } from "@/state/types";

export function PedidoResumen({ pedido }: { pedido: Pedido }) {
  const config = useConfigContext();

  const [obs, setObs] = useState(pedido.obs ?? "");

  const formasDePago = Object.entries(config.formas_de_pago);
  const subtotal = pedido.fotos
    .map((f) => f.precio || 0)
    .reduce((a, b) => a + b, 0);
  const descuento = pedido.descuento;
  const total = subtotal - descuento;

  return (
    <div>
      <PedidoSelectProducto pedido={pedido} />
      <h4>Mi compra</h4>

      {descuento > 0 && (
        <>
          <h5>
            Subtotal: {subtotal} {config.moneda}
          </h5>
          <h5>
            Descuento: {descuento} {config.moneda}
          </h5>
        </>
      )}

      <h5>
        Total: {total} {config.moneda}
      </h5>

      {formasDePago.length > 1 && <h4>Comprar con</h4>}

      <h5>Observaciones</h5>
      <div>
        <textarea value={obs} onChange={(e) => setObs(e.target.value)} />
      </div>

      {formasDePago.map(([formaPago, { nombre, logo }]) => (
        <button
          className="btn btn-default btn-login"
          onClick={() => comprarPedido(pedido.id, formaPago, obs)}
          key={nombre}
        >
          {logo ? (
            <img src={`${server}/images/formasdepago/${logo}`} alt={nombre} />
          ) : (
            nombre
          )}
        </button>
      ))}
    </div>
  );
}

export function PedidoSelectProducto({
  pedido,
  pref = "",
}: {
  pedido: Pedido;
  pref?: string;
}) {
  const config = useConfigContext();

  const [productoId, setProductoId] = useState<number>(
    config.temporadas[config.temporada].productos[0].id
  );

  return (
    <>
      <h4>Generales</h4>
      <div>
        <SelectProducto
          temporada={config.temporada}
          value={productoId}
          onSelect={setProductoId}
        />
      </div>
      <div>
        <button
          className="btn btn-default btn-login"
          onClick={() =>
            POST(`${pref}/pedido/set_producto`, {
              pedido_id: pedido.id,
              producto_id: productoId,
            })
          }
        >
          Aplicar
        </button>
      </div>
    </>
  );
}
